<template>
  <div class="news-wraper">
    <div class="tip bg1">
      <!-- <img src="" alt=""> -->
      <div class="site-content">
        <h1 class="main-title-primary">{{newsInfo.secondThemeName}}</h1>
        <h3 class="main-title-secondary"></h3>
      </div>
    </div>
    <!-- 新闻内容 -->
    <div class="mainBox" style="margin: 20px 0;">
      <p v-if="newsInfo.fistThemeName || newsInfo.secondThemeName">{{newsInfo.fistThemeName}} >> {{newsInfo.secondThemeName}}</p>
    </div>

    <div class="news-content" v-if="this.query == '1'">
      <h1>NQI简介</h1>
      <div class="time"></div>
      <div class="line"></div>
      <div class="content">
        <div class="text">
          2005年，联合国贸发组织（UNCTAD）和世界贸易组织（WTO）共同提出NQI的理念。2006年，联合国工业发展组织（UNIDO）和国际标准化组织（ISO）在总结质量领域一百多年实践经验基础上，正式提出计量、标准、合格评定（包括检验检测、认证认可）共同构成NQI
        </div>
        <div class="img">
          <img src="../../assets/images/nqijj-1.png" alt="">
          <div class="img-title">NQI的概念</div>
        </div>
        <div class="text">
          国家质量基础设施（NQI）是依赖于计量、标准、认可、合格评定和市场监管等要素，涉及政府治理、质量基础设施公共机构、质量基础设施服务、企业和消费者五个方面的完整体系。
        </div>
        <div class="img">
          <img src="../../assets/images/nqijj-2.png" alt="">
          <div class="img-title">NQI演变发展公私伙伴关系示意图</div>
        </div>
        <div class="text">
          现代的NQI已发展成为一个灵活的公私伙伴关系（Public-Private Partnership，PPP）体系，厘清了相关公共和私营部门的相关责任、优势和弱势。—— UNIDO
        </div>
        <div class="img">
          <img src="../../assets/images/nqijj-3.png" alt="">
          <div class="img-title">NQI三大支柱：计量、标准、合格评定（认证认可、检验检测）</div>
        </div>
        <div class="text">
          计量是控制质量的基础，标准引领质量提升，合格评定控制质量并建立质量信任，三者形成完整的技术链条，相互作用、相互促进，共同支撑质量的发展：计量是标准和合格评定的基准；标准是合格评定的依据，是计量的重要价值体现；合格评定是推动计量溯源水平提升和标准实施的重要手段。简单地说，计量解决准确测量的问题，质量中的量值要求由标准统一规范，标准执行得如何就需要通过检验检测和认证认可来判定。
        </div>
        <div class="text">
          自2005年联合国提出NQI的理念以来，人们对它的认识不断地丰富，是一个动态的过程，重视程度也不断提高。目前，加强NQI研究、建设和服务已经成为全球共识，发达国家分别以立法和规划等形式将NQI建设纳入国家战略，例如美国的《质量促进法案》和德国的“工业4.0”计划等。
        </div>
        <div class="text">
          国外的NQI研究起步较早，相对成熟，主要集中在两个方面：一是NQI体系架构，突出NQI整体的国家战略地位，并注重发挥市场的协同作用，例如美国是由政府主导逐渐转变为市场为主体的多元治理模式；二是多要素综合应用，聚焦于NQI多要素的协同服务，支撑产业和区域发展，例如联合国工业发展组织（UNIDO）提出了农产品加工领域的NQI方案。
        </div>
        <div class="text">
          我国已经将NQI建设作为国家战略，《中华人民共和国国民经济和社会发展第十四个五年规划和2035年远景目标纲要》就明确提出要完善国家质量基础设施，建设生产应用示范平台和标准计量、认证认可、检验检测、试验验证等产业技术基础公共服务平台。为此，科技部在2016年部署的“国家质量基础的共性技术研究与应用”重点专项（NQI专项）、2021年部署的“国家质量基础设施体系”重点专项（NQI专项），先后启动了约200个重点项目，实施的效果已经初步显现。
        </div>
      </div>
    </div>

    <div class="news-content" v-else-if="this.query == '4'">
      <h1>NQI专项5项成果亮相国家“十三五”科技创新成就展</h1>
      <div class="time"></div>
      <div class="line"></div>
      <div class="content">
        <div class="text">
          2021年10月21日至27日，国家“十三五”科技创新成就展在北京展览馆举办。玻尔兹曼常数的精确测定等5项NQI专项科研成果亮相展览。参展的5项NQI成果分别为：玻尔兹曼常数的精确测定、新一代时间标尺和传递技术应对秒定义变革、极区海洋重力校准技术、空间导航与定位NQI技术集成及示范应用以及跨境食品品质及身份特征识别检测技术。这些成果展现了NQI专项“十三五”期间在基础研究和科技创新方面取得的代表性成就。
        </div>
        <div class="sub-tit">
          一、中国计量科学研究院4项NQI成果
        </div>
        <div class="text">
          <b>（一）玻尔兹曼常数的精确测定。</b>玻尔兹曼常数的精确测定，是国际单位制温度单位重新定义的基础和开端。该项目实现了圆柱声学和噪声两种独立方法精确测定玻尔兹曼常数，测量结果均被国际科技数据委员会国际基本物理常数推荐值收录，为常数最终定值和2018年国际单位制温度单位开尔文的重新定义作出关键性贡献。项目成果为原级温度测量技术在尖端科学和重大领域的应用奠定了重要基础，荣获2018年度国家科技进步一等奖。
        </div>
        <div class="box">
          <div class="img">
            <img src="../../assets/images/nqixw-1.png" alt="">
            <div class="img-title">全球玻尔兹曼常数测定结果</div>
          </div>
          <div class="img">
            <img src="../../assets/images/nqixw-2.png" alt="">
            <div class="img-title">圆柱声学法核心部件-精密声学谐振腔</div>
          </div>
        </div>
        <div class="text" style="height: 40px;">
          <b>（二）时间频率基准及其传递技术研究</b>
        </div>
        <div class="text">
          时间是国际单位制7个基本单位中准确度最高、应用最广泛的基本量。高准确度时间频率计量是我国独立自主的国家时间频率体系的核心技术基础。该项目面向未来秒定义，成功自主研制10-18量级的锶原子光晶格钟，相当于35亿年不差一秒，是下一代国家时间频率基准的关键技术储备；攻克了时间频率基准频域和空间传递技术，可将最高精度时间量值传递给最终用户。项目成果可为全国时间频率同步网和未来北斗卫星导航系统建设提供关键技术支持。
        </div>
        <div class="box">
          <div class="img">
            <img src="../../assets/images/nqixw-3.png" alt="">
            <div class="img-title">锶原子光晶格钟实验系统</div>
          </div>
          <div class="img">
            <img src="../../assets/images/nqixw-4.png" alt="">
            <div class="img-title">锶原子光晶格钟核心部件——磁光阱</div>
          </div>
        </div>
        <div class="text" style="height: 40px;">
          <b>（三）空间导航与定位NQI技术集成及示范应用</b>
        </div>
        <div class="text">
          该项目攻克了精准时间频率传递与链路校准关键技术，自主研制北斗精准时间频率传递计量装置，不确定度为2ns，首次实现北斗洲际链路万公里以上时间传递，并完成了七大洲的北斗时间传递评估，为北斗系统的全球化应用服务奠定了技术基础。项目建立的北斗时间监测站，成为国际时间频率咨询委员会（CCTF）GNSS工作组指定的唯一官方数据源。
        </div>
        <div class="box">
          <div class="img">
            <img src="../../assets/images/nqixw-5.png" alt="">
            <div class="img-title">北斗时间远程传递装置</div>
          </div>
          <div class="img">
            <img src="../../assets/images/nqixw-6.png" alt="">
            <div class="img-title">北斗时间传递比对及效果评</div>
          </div>
        </div>
        <div class="text" style="height: 40px;">
          <b>（四）极区海洋重力校准技术</b>
        </div>
        <div class="text">
          和平利用极地资源开展科学考察，是世界主要国家开拓未来发展空间的重大科技活动。该项目首次使用自主可控的绝对重力仪，在南极验证了时空基准的关键技术方案，建立了中山站首个国家级重力加速度校准点，并通过自主研发的远程时空基准量传实验系统，实现了北京—南极远程时间频率精准传递，为保障我国南极重力测量结果的溯源性和准确性奠定了基础。
        </div>
        <div class="img">
          <img src="../../assets/images/nqixw-7.png" alt="">
          <div class="img-title">NIM-3C型激光干涉绝对重力仪</div>
        </div>
        <div class="sub-tit">
          二、中国检验检疫科学研究院1项NQI成果
        </div>
        <div class="text">
          “跨境食品品质及身份特征识别检测技术”成果，来源于国家重点研发计划“现代食品加工及粮食收储运技术与装备”重点专项项目，成果针对燕窝、三文鱼、乳制品、食用油等跨境食品，突破身份鉴别和危害物识别等核心关键技术，构建了基于多组学的跨境食品物种、产地和品质识别技术体系，成果应用于监管部门、检测机构和食品企业，显著提升了我国跨境食品品质与质量安全水平。
        </div>
      </div>
    </div>

    <div class="news-content" v-else>
      <template v-if="!newsInfo.htmlFile">
        <h1>{{newsInfo.title}}</h1>
        <div class="time">
          <span v-if="newsInfo.publishTime">发布时间：{{newsInfo.publishTime}} &nbsp;</span>
          <span v-if="newsInfo.createName">信息来源：{{newsInfo.createName}}</span>
        </div>
        <div class="line"></div>
      </template>
      <div class="news-html" v-html="newsInfo.content || newsInfo.brief"></div>
    </div>

    <div class="tip-bottom"></div>
  </div>
</template>

<script>
import * as richEdit from './richEdit.js'
import axios from 'axios'
export default {
  name: 'newsDetail',
  data () {
    return {
      newsInfo: {},
      richEdit,
      query: ''
    };
  },
  created () {
    this.query = this.$route.query.id;
  },
  mounted () {
    this.getNews();
  },
  methods: {
    getNews () {
      const _self = this;
      if (this.query !== 'type') {
        let url = '/dataapi/open/nqi/notice/queryById';
        _self.fetch(url, {id: this.query}).then(res => {
          _self.newsInfo = res.result;
          if (_self.newsInfo.htmlFile) {
            axios.get('/dataapi/sys/common/static/' + _self.newsInfo.htmlFile).then(function (response) {
              _self.newsInfo.content = response
            })
          }
        });
      }
    }
  }
};
</script>

<style lang='less' scoped>
.mainBox {
  width: calc(100% - 320px);
  margin: 0 auto;
}
.news-wraper {
  background: #f2f2f2;
  // min-height: 800px;
  //  position: relative;
  .bg1 {
    background: url("../../assets/images/nqi1.png") no-repeat;
  }
  .bg2 {
    background: url("../../assets/images/nqi2.png") no-repeat;
  }
  .bg3 {
    background: url("../../assets/images/nqi3.png") no-repeat;
  }
  .bg4 {
    background: url("../../assets/images/nqi4.png") no-repeat;
  }
  .tip {
    height: 400px;
    .site-content {
      width: 100%;
      height: 100%;
      position: relative;
      background: rgba(96, 96, 96, 0.6);
      .main-title-secondary {
        // margin-top: 10px;
        font-size: 14px;
        color: #fff;
        width: 800px;
        position: absolute;
        left: 50%;
        top: 50%;
        margin-left: -400px;
        text-align: center;
      }
      .main-title-primary {
        //  margin-top: 00px;
        font-weight: 700;
        color: #fff;
        width: 600px;
        position: absolute;
        left: 50%;
        top: 30%;
        margin-left: -300px;
        text-align: center;
      }
    }
  }
  .news-content {
    .mainBox;
    background: #fff;
    margin-bottom: 60px;
    .content{
      width: calc(100% - 320px);
      margin: 0 auto;
      padding-bottom: 40px;
      overflow: hidden;
      .sub-tit{
        font-size: 24px;
        font-weight: bold;
        margin-top: 24px;
      }
      .box{
        margin-top: 32px;
        display: flex;
        justify-content: space-around;
        .img {
          text-align: center;
          img {
            width: 600px;
            height: 500px;
            margin: 0 auto;
          }
          .img-title {
            font-size: 20px;
            margin-top: 12px;
          }
        }
      }
      .text {
        font-size: 20px;
        line-height: 36px;
        text-indent: 2em;
        margin-top: 16px;
      }
      .img {
        text-align: center;
        img {
          width: calc(100% - 720px);
          height: 500px;
          margin: 0 auto;
        }
        .img-title {
          font-size: 20px;
          margin-top: 12px;
        }
      }
    }
    h1 {
      .mainBox;
      padding-top: 60px;
      text-align: center;
      word-wrap: break-word;
    }
    .time {
      .mainBox;
      padding: 20px 0;
      color: #808080;
      font-size: 12px;
      text-align: center;
    }
    .line {
      .mainBox;
      border-bottom: 1px solid #d4d4d4;
      margin-bottom: 40px;
    }
    .news-html {
      .mainBox;
      padding-bottom: 40px;
      overflow: hidden;
      //  min-height: 300px;
    }
  }
  .tip-bottom {
    height: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/detail/newsDetail.vue